var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 15a.75.75 0 0 1-.75-.75A5.256 5.256 0 0 0 17.25 9H10v3.25c0 .66-.794.994-1.268.542l-5.5-5.25a.749.749 0 0 1 0-1.084l5.5-5.25C9.208.754 10 1.092 10 1.75V5h6.25C20.523 5 24 8.477 24 12.75v1.5a.75.75 0 0 1-.75.75z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22.25V19H7.75C3.477 19 0 15.523 0 11.25v-1.5a.75.75 0 0 1 1.5 0A5.256 5.256 0 0 0 6.75 15H14v-3.25a.75.75 0 0 1 1.268-.542l5.5 5.25a.749.749 0 0 1 0 1.084l-5.5 5.25c-.477.454-1.268.116-1.268-.542z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.e691d033d9c409cb4a46493203e4972a.svg";
export { ForwardRef as ReactComponent };